const logIt = function (o, tag, logFunc) {
    if (ApexChat.isInDevMode) {
        let prefix = tag || '';
        const date = new Date();
        const logTime = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}`;
        let trace = `${logTime}::`;
        if (logFunc && typeof logFunc === 'function') {
            if (logFunc == console.error) {
                prefix = 'Error:: ';
            }
            trace += prefix + o;
            logFunc(trace);
        } else {
            trace += prefix + o;
            window.console.log(trace);
        }
    }
};
export default logIt;
